import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements Overlayable{
  @Input('text') text = "";
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
}
